import React from "react";

import { withNamespaces } from 'react-i18next';

const AcLocaisCulto = ({ t }) => {
  return (
    <>
      <div className="accordion" id="accordionExample">
        {/* 1 - CATOLICA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              {t('moduleCidadeAveiro:S2.ST5.A.A1.T')}
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <p className="p_next">
                  {t('moduleCidadeAveiro:S2.ST5.A.A1.P')}
                </p>
                <ul className="bulletpoint lista">
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A1.UL.LI1.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A1.UL.LI1.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A1.UL.LI1.T')}
                    </a>
                  </li>
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A1.UL.LI2.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A1.UL.LI2.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A1.UL.LI2.T')}
                    </a>
                  </li>
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A1.UL.LI3.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A1.UL.LI3.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A1.UL.LI3.T')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - PROTESTANTE */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              {t('moduleCidadeAveiro:S2.ST5.A.A2.T')}
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <p className="p_next">{t('moduleCidadeAveiro:S2.ST5.A.A2.P')}</p>
                <ul className="bulletpoint lista">
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI1.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI1.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI1.T')}
                    </a>
                  </li>
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI2.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI2.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI2.T')}
                    </a>
                  </li>
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI3.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI3.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI3.T')}
                    </a>
                  </li>
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI4.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI4.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI4.T')}
                    </a>
                  </li>
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI5.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI5.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A2.UL.LI5.T')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 3 - JUDAICA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingThree">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              {t('moduleCidadeAveiro:S2.ST5.A.A3.T')}
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <p className="p_next">
                {t('moduleCidadeAveiro:S2.ST5.A.A3.P')}
                </p>
                <ul className="bulletpoint lista">
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A3.UL.LI1.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A3.UL.LI1.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A3.UL.LI1.T')}
                    </a>
                  </li>
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A3.UL.LI2.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A3.UL.LI2.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A3.UL.LI2.T')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 4 - MUÇULMANA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingFour">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              {t('moduleCidadeAveiro:S2.ST5.A.A4.T')}
            </button>
          </h2>
          <div
            id="collapseFour"
            className="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <p className="p_next">
                {t('moduleCidadeAveiro:S2.ST5.A.A4.P')}
                </p>
                <ul className="bulletpoint lista">
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI1.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI1.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI1.T')}
                    </a>
                  </li>
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI2.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI2.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI2.T')}
                    </a>
                  </li>
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI3.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI3.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI3.T')}
                    </a>
                  </li>
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI4.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI4.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A4.UL.LI4.T')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 5 - HINDU */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingFive">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              {t('moduleCidadeAveiro:S2.ST5.A.A5.T')}
            </button>
          </h2>
          <div
            id="collapseFive"
            className="accordion-collapse collapse"
            aria-labelledby="headingFive"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <p className="p_next">
                {t('moduleCidadeAveiro:S2.ST5.A.A5.P')}
                </p>
                <ul className="bulletpoint lista">
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A5.UL.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A5.UL.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A5.UL.T')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 6 - BUDISTA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingSix">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              {t('moduleCidadeAveiro:S2.ST5.A.A6.T')}
            </button>
          </h2>
          <div
            id="collapseSix"
            className="accordion-collapse collapse"
            aria-labelledby="headingSix"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <p className="p_next">
                {t('moduleCidadeAveiro:S2.ST5.A.A6.P')}
                </p>
                <ul className="bulletpoint lista">
                  <li>
                    <a
                      className="link"
                      title={t('moduleCidadeAveiro:S2.ST5.A.A6.UL.Title')}
                      target="_blank"
                      rel="noreferrer"
                      href={t('moduleCidadeAveiro:S2.ST5.A.A6.UL.Link')}
                    >
                      {t('moduleCidadeAveiro:S2.ST5.A.A6.UL.T')}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(AcLocaisCulto);
